module.exports = __webpack_public_path__ + "static/media/livingstone_morrison_BIO.7374c398.pdf";